import { CUSTOM_ICONS } from '@nexelem/icons';
import { Status, StatusColors } from '@nexelem/components';
import { ProLightIndustryWindows } from '@nexelem/icons/ProLightIndustryWindows';
import { hasNodeOverdue } from '../utils';
import { getTaskTypeIcon } from '../../../../../pages/generic/Products/components/TaskDetailDrawer/components/getTaskTypeIcon';

export type NodeIconProps = {
  statusColor?: StatusColors;
  taskType?: string;
  dueDate?: Date;
  endDate?: Date;
  isOrder?: boolean;
};
export const NodeIcon = ({ statusColor, dueDate, taskType, endDate, isOrder }: NodeIconProps) => {
  const taskTypeName = isOrder ? 'Order' : taskType;

  return (
    <div className="relative">
      <Status
        className="text-s16"
        color={statusColor}
        Icon={taskTypeName ? getTaskTypeIcon(taskTypeName) : ProLightIndustryWindows}
        variant="icon"
      />
      {dueDate && hasNodeOverdue(dueDate, endDate) && (
        <CUSTOM_ICONS.OverdueClock className="absolute -top-1 -right-1 h-4 w-4 text-text-secondary-darker" />
      )}
    </div>
  );
};
